export const RANGE_MIN_VALUE = 0;

export const RANGE_MAX_VALUE = 100;

export const FILTER_UPDATE_DEBOUNCE = 1000;
